// How a comment reads (TX-US-0037). The role codes are the API's; the words are ours.

const ROLE_LABELS = {
  COMMERCIAL: 'BD',
  OPERATIONS: 'Operations',
  COMPLIANCE: 'Compliance',
  RISK: 'Risk',
  LEGAL: 'Legal',
};

export const roleLabel = (code) => ROLE_LABELS[code] ?? code;

// The roles a comment's author held when they wrote it, as the comment says them.
export const authorRoles = (comment) => comment.author_roles.map(roleLabel).join(', ');

// Mirrors MAX_COMMENT_LENGTH in trex/counterparties/comments/models.py.
export const MAX_COMMENT_LENGTH = 4000;
